export const PAY_DASHBOARD_TOUR_PREFERENCE_KEY = 'payDashboardTourActive';
